import { FullscreenContext } from '@/app/FullscreenProvider';
import { useContext } from 'react';

export function useFullscreen() {
    const context = useContext(FullscreenContext);

    if (!context) {
        throw new Error('useFullscreen must be used within a FullscreenProvider');
    }

    return context;
}
